import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import { FiArrowRight, FiMapPin, FiChevronDown } from "react-icons/fi";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import useReducedMotion from "../../hooks/useReducedMotion";
import "./Hero.css";

export default function Hero() {
  const rootRef = useRef(null);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (reducedMotion) {
        gsap.set([".hero__label", ".hero__word", ".hero__sub", ".hero__actions", ".hero__meta"], { opacity: 1, y: 0 });
        return;
      }
      const tl = gsap.timeline({ defaults: { ease: "power3.out" } });
      tl.fromTo(".hero__label", { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.6 })
        .fromTo(".hero__word", { opacity: 0, y: 60 }, { opacity: 1, y: 0, duration: 0.8, stagger: 0.1 }, "-=0.3")
        .fromTo(".hero__sub", { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6 }, "-=0.35")
        .fromTo(".hero__actions", { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6 }, "-=0.4")
        .fromTo(".hero__meta > *", { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.5, stagger: 0.08 }, "-=0.35");

      gsap.to(".hero__bg", { scale: 1.12, duration: 18, ease: "none", repeat: -1, yoyo: true });
    }, rootRef);
    return () => ctx.revert();
  }, [reducedMotion]);

  return (
    <section className="hero" ref={rootRef}>
      <div className="hero__bg" aria-hidden="true" />
      <div className="hero__overlay" aria-hidden="true" />
      <div className="hero__lines" aria-hidden="true">
        <span /><span /><span /><span /><span />
      </div>
      <span className="hero__ghost" aria-hidden="true">NO LIMITS</span>

      <div className="container hero__content">
        <span className="hero__label eyebrow">Stronger Every Day</span>
        <h1 className="hero__headline">
          <span className="hero__word">Build Your Body.</span>
          <br />
          <span className="hero__word hero__word--accent">Transform Your Life.</span>
        </h1>
        <p className="hero__sub">
          Firm Fit Factory is Peelamedu's engine room for strength, conditioning and
          real transformation — coached training, honest programming, no shortcuts.
        </p>
        <div className="hero__actions">
          <Link to="/contact" className="btn btn-primary">
            Start Your Journey <FiArrowRight className="btn-icon" aria-hidden="true" />
          </Link>
          <Link to="/programs" className="btn btn-outline">Explore Programs</Link>
        </div>
        <div className="hero__meta">
          <span className="hero__location"><FiMapPin aria-hidden="true" /> Peelamedu, Coimbatore</span>
          <div className="hero__socials">
            <a href="https://instagram.com/firmfitfactory" aria-label="Instagram (placeholder link)"><FaInstagram aria-hidden="true" /></a>
            <a href="https://facebook.com/firmfitfactory" aria-label="Facebook (placeholder link)"><FaFacebookF aria-hidden="true" /></a>
            <a href="https://wa.me/919500886368" aria-label="WhatsApp"><FaWhatsapp aria-hidden="true" /></a>
          </div>
        </div>
      </div>

      <div className="hero__scroll" aria-hidden="true">
        <span>Scroll</span>
        <FiChevronDown className="hero__scroll-icon" />
      </div>
    </section>
  );
}
